var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticClass:"ml-1",attrs:{"small":""},on:{"click":function($event){return _vm.copyToClipBoard(_vm.text)}}},[_vm._v("\n    content_copy\n  ")]),(_vm.copied)?_c('small',{staticClass:"ml-1",staticStyle:{"color":"green"}},[_vm._v("copied")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }